import { Box, useTheme } from "@mui/material";
import Text from "../../../theme/text/Text";
import Shbutton from "../../../theme/buttons/Shbutton";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import ArrowLeftAltIcon from '@mui/icons-material/ArrowLeftAltIcon';
import { tokens } from "../../../../theme";
import ContactsIcon from '@mui/icons-material/Contacts';
import { useCallback, useEffect, useMemo, useState } from "react";

import SidepanelHeaderActiongroup from "../../../theme/sidepanel2/SidepanelHeaderActiongroup";
import { useGridApiRef } from "@mui/x-data-grid";
import RelationContacts from "./Views/RelationContacts";
import Stock from "./Views/Stock";
import Palletspots from "./Views/Palletspots";
import { useTranslation } from 'react-i18next';
import DetailsPanel from "./Views/Details";
import Sidepanel2 from "../../../theme/sidepanel2/Sidepanel2";
import { spRelationDetailsConfig } from "./spRelationDetailsConfig";
import { useDeleteRelationMutation, useEditRelationMutation, useGetRelationQuery } from "../../../../newapi/global/relation/relationSlice";
import { general_states } from "../../../../utils/staticEnums";
import ShRowSkeleton from "../../../theme/skeleton/ShRowSkeleton";
import MConfirmDelete from "../../Modals/MConfirmDelete";
import MConfirmation from "../../Modals/MConfirmation";
import { showToastMessageDeleteRequest, showToastMessageUpdateRequest } from "../../../../utils/toasts";

import ArchiveIcon from '@mui/icons-material/Archive';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ButtonGroup from "../../../theme/buttons/ButtonGroup";
import MAddRelationLogo from "../../Modals/MAddRelationLogo";
import Settings from "./Views/Settings";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../utils/permissions';
import { useSelector } from "react-redux";

const SidePanelActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return (
        <SidepanelHeaderActiongroup>
            <Shbutton isCancel={true} 
                onClick={() => props.setIsExtended(false)} 
                color="primary" 
                variant="text" 
                startIcon={<ArrowRightAltIcon/>}
            >
                Cancel
            </Shbutton>
            <ButtonGroup version={2} isSidepanel>
                {props.hasModifyPrivilege && props.relationState !== general_states.ACTIVE && (
                <Shbutton
                    block
                    className={"group-btn"}
                    onClick={props.activateAction}
                    color={theme.palette.mode === "dark" ? "blue": "primary"}
                    variant="contained"
                    endIcon={<CheckCircleOutlineIcon />}
                >
                    {t('activate')}
                </Shbutton>
                )}
                {props.hasModifyPrivilege && props.relationState !== general_states.BLOCKED && (
                <Shbutton
                    block
                    className={"group-btn"}
                    onClick={props.blockAction}
                    color="purple"
                    variant="contained"
                    endIcon={<BlockIcon />}
                >
                    {t('block')}
                </Shbutton>
                )}
                {props.hasModifyPrivilege && props.relationState !== general_states.INACTIVE && (
                <Shbutton
                    block
                    className={"group-btn"}
                    onClick={props.deleteAction}
                    isLoading={props.deleteRelationLoading}
                    color="red"
                    variant="contained"
                    endIcon={<ArchiveIcon />}
                >
                    {t('archive')}
                </Shbutton>
                )}
            </ButtonGroup>

        </SidepanelHeaderActiongroup>
    )
}

const SpRelationDetails = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [logoOpen,setLogoOpen] = useState(false);

    const hasModifyPrivilege = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RELATION_MANAGE])
    );

    const { data: relationData, isLoading,isFetching,isError } = useGetRelationQuery(props.relationId,
    {
        skip: !props.relationId
    });

    const defaultIcon = useMemo(() => ({
        theme: theme.palette.mode === "dark" ? "blue" : "primary",
        content: <ContactsIcon/>,
        onClick: () => setLogoOpen(true),
    }), [theme.palette.mode,props.relationId]);

    const defaultOptions = useMemo(() => [
        { component: <ShRowSkeleton heading={t("phone")} /> },
        { component: <ShRowSkeleton heading={t("email")} /> },
        { component: <ShRowSkeleton heading={t("website")} /> },
    ], [t]);
    
    const setIsExtendedCallback = useCallback(() => props.setIsExtended(false), [props.setIsExtended]);

    // Memoize the default state to avoid recalculating it on every render
    const defaultState = useMemo(() => ({
        title: "",
        subTitle: "",
        options: defaultOptions,
        icon: defaultIcon,
        actions:<SidePanelActions setIsExtended={setIsExtendedCallback} hasModifyPrivilege={hasModifyPrivilege} relationState={relationData?.state}/>
    }), [defaultIcon,defaultOptions, setIsExtendedCallback]);

    const [panel, setPanel] = useState(defaultState);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setPanel(defaultState);
    }, [isFetching,props.relationId,theme.palette.mode])
    

    const [editRelation] = useEditRelationMutation();
    const [blockConfirmOpen, setBlockConfirmOpen] = useState(false);
    const [activateConfirmOpen, setActivateConfirmOpen] = useState(false);

    const confirmBlock = async () => {
        try {
            const response = await editRelation({ id: props.relationId, state: general_states.BLOCKED }).unwrap();
            showToastMessageUpdateRequest(t, response);
            props.setIsExtended(false);
        } catch (err) {
            showToastMessageUpdateRequest(t, {success: false, error: err.error});
        }
    };

    const confirmActivate = async () => {
        try {
            const response = await editRelation({ id: props.relationId, state: general_states.ACTIVE }).unwrap();
            showToastMessageUpdateRequest(t, response);
            props.setIsExtended(false);
        } catch (err) {
            showToastMessageUpdateRequest(t, {success: false, error: err.error});
        }
    };

    const [DeleteRelationMutation,{isLoading:deleteRelationLoading}] = useDeleteRelationMutation();
    const confirmDelete = async () => {
        try {
            if(deleteRelationLoading) return;

            const response = await DeleteRelationMutation({id: props.relationId}).unwrap();
            
            showToastMessageDeleteRequest(t, response, t('archive_successfull'));
            props.setIsExtended(false);
        } catch (err) {
            showToastMessageDeleteRequest(t, {success: false, error: err.error});
        }
    };
    const handleDeleteClick = async () => {
        setOpen(true);
    };

    const confirmDeleteModal = {
        data: relationData?.name,
        open: open,
        setOpen: setOpen,
        confirm: confirmDelete
    }

    useEffect(() => {
        if (!isLoading && !isFetching && relationData) {
            const options = [
                {
                    heading: t('phone'),
                    content: relationData.phone
                },
                {
                    heading: t('email'),
                    content: relationData.email
                },
                {
                    heading: t('website'),
                    content: relationData.website
                },
            ];

            if (relationData.invoiceCategory) {
                options.push({
                    heading: t('category'),
                    content: relationData.invoiceCategory.name
                });
            }

            setPanel(prevPanel => ({
                ...prevPanel,
                title: relationData.name,
                subTitle: [""],
                options: options,
                actions: <SidePanelActions setIsExtended={setIsExtendedCallback} deleteRelationLoading={deleteRelationLoading} deleteAction={handleDeleteClick} blockAction={() => setBlockConfirmOpen(true)} activateAction={() => setActivateConfirmOpen(true)} hasModifyPrivilege={hasModifyPrivilege} relationState={relationData?.state}/>
            }));
        }
    }, [relationData, isLoading, deleteRelationLoading, isFetching, t,theme.palette.mode]);


    return (
        <>
            <Sidepanel2
                skeleton={isLoading || isFetching}
                tabConfig={spRelationDetailsConfig}
                content={panel} 
                isExtended={props.isExtended} 
                setIsExtended={props.setIsExtended}>
                    <>
                        <DetailsPanel config={spRelationDetailsConfig.details} data={relationData} setIsExtended={props.setIsExtended} />
                        <RelationContacts config={spRelationDetailsConfig.relationContacts} relationId={props.relationId}/>
                        <Stock config={spRelationDetailsConfig.stock} data={relationData} setIsExtended={props.setIsExtended} />
                        <Palletspots config={spRelationDetailsConfig.palletspots} relationId={props.relationId} />
                        <Settings config={spRelationDetailsConfig.settings} relationId={props.relationId} setIsExtended={props.setIsExtended}/>
                    </>
            </Sidepanel2>
            <MConfirmDelete
                open={confirmDeleteModal.open}
                title={t('archive_relation')}
                content={t('archive_relation_content')}
                confirmBtn={t('archive')}
                handleClose={() => confirmDeleteModal.setOpen(false)}
                data={confirmDeleteModal.data}
                confirm={confirmDeleteModal.confirm}
            />

            <MAddRelationLogo
                open={logoOpen}
                handleClose={() => setLogoOpen(false)}
                relationId={props.relationId}
            />

            <MConfirmation
                open={blockConfirmOpen}
                handleClose={() => setBlockConfirmOpen(false)}
                title={t('block_relation')}
                subtitle={t('block_relation_content')}
                confirm={confirmBlock}
            />

            <MConfirmation
                open={activateConfirmOpen}
                handleClose={() => setActivateConfirmOpen(false)}
                title={t('activate_relation')}
                subtitle={t('activate_relation_content')}
                confirm={confirmActivate}
            />
        </>
    );
};

export default SpRelationDetails;